import { OfficeBranch } from './libs/office-branch-list';
import { OfficeBranchDetailComponent } from './libs/office-branch-detail';
import { OfficeBranchTabs } from './libs/office-branch-tabs';

export { OfficeBranch, OfficeBranchDetailComponent, OfficeBranchTabs };
